module.exports = __webpack_public_path__ + "static/media/banniereSpecimen.11146e25.png";